
// SVG Icon: compass-outer-skeleton
export default { id: "terriajs-compass-outer-skeleton" };
export const id = "terriajs-compass-outer-skeleton";
export const name = "compass-outer-skeleton";
